export const TYPE_IRRELEVANT = 'irrelevant';
export const TYPE_YES = 'yes';
export const TYPE_NO = 'no';

const LABELS = {
	[TYPE_IRRELEVANT]: 'Egal',
	[TYPE_YES]: 'Ja',
	[TYPE_NO]: 'Nein',
};

export function getLabel (type)
{
	return LABELS[type];
}
